document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================
     CARRUSEL
  ========================================== */

  document.querySelectorAll(".aa-slider").forEach((slider) => {

    const viewport = slider.querySelector(".aa-viewport");
    const track = slider.querySelector(".aa-track");
    const slides = [...slider.querySelectorAll(".aa-slide")];

    const prev = slider.querySelector(".aa-prev");
    const next = slider.querySelector(".aa-next");

    if (!viewport || !track || slides.length === 0) return;

    let index = 0;

    function slidesPerView() {
      if (window.innerWidth < 768) return 2;
      if (window.innerWidth < 1100) return 3;
      return 4;
    }

    function update() {
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || 0);
      const slideWidth = slides[0].getBoundingClientRect().width;
      const move = index * (slideWidth + gap);

      track.style.transform = `translateX(-${move}px)`;

      const max = Math.max(0, slides.length - slidesPerView());

      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= max;
    }

    if (next) {
      next.addEventListener("click", () => {
        const max = Math.max(0, slides.length - slidesPerView());
        if (index < max) {
          index++;
          update();
          
        }
      });
    }

    if (prev) {
      prev.addEventListener("click", () => {
        if (index > 0) {
          index--;
          update();
        }
      });
    }

    window.addEventListener("resize", () => {
      const max = Math.max(0, slides.length - slidesPerView());
      if (index > max) index = max;
      update();
    });


    update();

    /* ==========================================
       TOUCH SWIPE (MÓVIL)
    ========================================== */

    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    viewport.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      currentX = startX;
      isDragging = true;
      clearInterval(autoSlide);
    }, { passive: true });

    viewport.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    viewport.addEventListener("touchend", () => {
      if (!isDragging) return;

      const diff = startX - currentX;
      const max = Math.max(0, slides.length - slidesPerView());

      if (Math.abs(diff) > 40) {
        if (diff > 0 && index < max) index++;
        if (diff < 0 && index > 0) index--;
        update();
      }

      isDragging = false;
      restartAutoSlide();
    });

    /* ==========================================
       AUTO SLIDE
    ========================================== */

    function autoAdvance() {
      const max = Math.max(0, slides.length - slidesPerView());
      if (index >= max) {
        index = 0;
      } else {
        index++;
      }
      update();
    }

    let autoSlide = setInterval(autoAdvance, 3500);

    function restartAutoSlide() {
      clearInterval(autoSlide);
      autoSlide = setInterval(autoAdvance, 3500);
    }

    slider.addEventListener("mouseenter", () => clearInterval(autoSlide));
    slider.addEventListener("mouseleave", restartAutoSlide);

    slider.addEventListener("touchstart", () => clearInterval(autoSlide), { passive: true });
    slider.addEventListener("touchend", restartAutoSlide);

  });

  /* ==========================================
     CONTADOR
  ========================================== */

  const days = document.querySelector('.days');
  const hours = document.querySelector('.hours');
  const minutes = document.querySelector('.minutes');
  const seconds = document.querySelector('.seconds');

  if (days && hours && minutes && seconds) {

    function getNextMonday() {
      const now = new Date();
      const target = new Date(now);

      let diff = (8 - now.getDay()) % 7;
      if (diff === 0) diff = 7;

      target.setDate(now.getDate() + diff);
      target.setHours(0, 0, 0, 0);

      return target;
    }

    function updateCountdown() {
      const now = new Date();
      const target = getNextMonday();
      const distance = target - now;

      const d = Math.floor(distance / 86400000);
      const h = Math.floor((distance % 86400000) / 3600000);
      const m = Math.floor((distance % 3600000) / 60000);
      const s = Math.floor((distance % 60000) / 1000);

      days.textContent = String(d).padStart(2, '0');
      hours.textContent = String(h).padStart(2, '0');
      minutes.textContent = String(m).padStart(2, '0');
      seconds.textContent = String(s).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ==========================================
     AGREGAR AL CARRITO AJAX
  ========================================== */

  document.querySelectorAll('.aa-add-cart').forEach((button) => {

    button.addEventListener('click', async () => {

      const id = button.dataset.variant;
      if (!id) return;

      button.disabled = true;
      button.textContent = 'Agregando...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });

        if (!response.ok) throw new Error();

        button.textContent = '✓ Agregado';
        document.dispatchEvent(new CustomEvent('cart:refresh'));

      } catch {
        button.textContent = 'Error';
      }

      setTimeout(() => {
        button.disabled = false;
        button.textContent = 'Agregar al carrito';
      }, 3500);

    });

  });

});
